import React from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import { ManagedPopup } from 'js/components/common/Popup';
import { useCombinedOnClose } from 'js/components/common/PopupManager';
import { DynamicChangePassword } from 'js/components/main/DynamicChangePassword';

import * as Types from './types';
import { DEFAULT_CHANGE_PASSWORD_WITHOUT_OLD_FORM } from './constants';

import style from './ChangePasswordPopup.scss';

export const ChangePasswordPopup: React.FC<Types.IChangePassPopupProps> = ({ id, onSuccess, onClose, showOldPassword }) => {
    const closePopup = useCombinedOnClose(onClose, id);
    const loginChangePassword = useAppSelector(prop('loginChangePassword'));

    return (
        <ManagedPopup
            onClose={closePopup}
            className={style.container}
            layerClassNames={{ layout: style.layout }}
            title="playtech.mobile.system.changePass.title"
        >
            <DynamicChangePassword
                isPasFlow
                onClose={closePopup}
                onSuccess={onSuccess}
                showOldPassword={showOldPassword}
                form={loginChangePassword || DEFAULT_CHANGE_PASSWORD_WITHOUT_OLD_FORM}
            />
        </ManagedPopup>
    );
};
